import { render, staticRenderFns } from "./CreatorLivestreamIdleFaq.vue?vue&type=template&id=413bebf4&"
import script from "./CreatorLivestreamIdleFaq.vue?vue&type=script&lang=js&"
export * from "./CreatorLivestreamIdleFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports